import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import Button from '../../components/Button';
import { multiLanguage } from "../../hoc";
// import { assetsPath } from "../../utils";

@multiLanguage()
export default class Welcome extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
  };
  handleClickReadMe = () => {
    console.log('handle click read me >>>> ');
  }
  renderTitle = (data) => {
    return _.map(data, item => <h1>{item}</h1>);
  }
  renderSubTitle = (data) => {
    return _.map(data, item => <h2>{item}</h2>);
  }
  renderDetail = (data) => {
    return _.map(data, item => <h3>{item}</h3>);
  }
  render() {
    const { page, t, title, subContent, content, button } = this.props;
    // console.log('page welcome >>>> ', page);
    // button={_.get(pageData, "button")}
    return (
      <div className="section-welcome">
        <div className="content-welcome">
          { this.renderTitle(t(title)) }
          { this.renderSubTitle(t(subContent)) }
          { this.renderDetail(t(content)) }
          <Button
            type="primary"
            hoverStyle={{ backgroundColor: "#ffffff", color: "#04a8a6" }}
            defaultStyle={{ padding: "10px 50px", margin: "15px", backgroundColor: "#04a8a6", color: "#ffffff", border: "none" }}
            onClick={this.handleClickReadMe}
          >
            {t(button)}
          </Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/Welcome.js